import {
  Close,
  WelcomeButton,
  WelcomeContainer,
  WelcomeContent,
  WelcomeTitle,
  WelcomeTitleArea,
  WelcomeWrapper,
} from './style'

import React from 'react'
import useFirstVisit from 'context/tour-guide/services/use-tourguide'
import { useIsMetaMaskMobile } from 'hooks/use-Is-MetaMask-Mobile'
import { useTourGuide } from 'context/tour-guide/use-tour-guide'

export const WelcomeModal: React.FC = () => {
  // handle local storage
  const { firstVisit, firstVisitComplete } = useFirstVisit()
  const { requestStartTour } = useTourGuide()
  const isMetaMaskMobile = useIsMetaMaskMobile()

  // click event
  const handleShowMeAround = () => {
    firstVisitComplete()
    requestStartTour()
  }

  const closeTour = () => {
    firstVisitComplete()
    localStorage.setItem('tourCompleted', 'true')
  }

  if (isMetaMaskMobile || !firstVisit) return null

  return (
    <WelcomeWrapper>
      <WelcomeContainer>
        <WelcomeTitleArea>
          <WelcomeTitle>Welcome to Phuture</WelcomeTitle>
          <Close onClick={closeTour} />
        </WelcomeTitleArea>
        <WelcomeContent>
          We provide passive exposure to crypto through our index funds and structured products.
        </WelcomeContent>
        <WelcomeButton onClick={handleShowMeAround}>Show me around</WelcomeButton>
      </WelcomeContainer>
    </WelcomeWrapper>
  )
}

export default WelcomeModal
